import Nav from "@/components/oakbridge/Nav";
import Hero from "@/components/oakbridge/Hero";
import ValueProps from "@/components/oakbridge/ValueProps";
import Process from "@/components/oakbridge/Process";
import Tiers from "@/components/oakbridge/Tiers";
import Calculator from "@/components/oakbridge/Calculator";
import Ongoing from "@/components/oakbridge/Ongoing";
import InquiryForm from "@/components/oakbridge/InquiryForm";
import FAQ from "@/components/oakbridge/FAQ";
import Footer from "@/components/oakbridge/Footer";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Landing({ currency, setCurrency, rates }) {
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [estimateGbp, setEstimateGbp] = useState(150);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Small delay so components render before scrolling
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <main data-testid="landing-page">
      <Nav currency={currency} setCurrency={setCurrency} rates={rates} />
      <Hero currency={currency} rates={rates} />
      <ValueProps />
      <Tiers currency={currency} rates={rates} />
      <Calculator
        currency={currency}
        rates={rates}
        selectedFeatures={selectedFeatures}
        setSelectedFeatures={setSelectedFeatures}
        estimateGbp={estimateGbp}
        setEstimateGbp={setEstimateGbp}
      />
      <Ongoing currency={currency} rates={rates} />
      <Process />
      <InquiryForm
        currency={currency}
        rates={rates}
        selectedFeatures={selectedFeatures}
        estimateGbp={estimateGbp}
      />
      <FAQ currency={currency} rates={rates} />
      <Footer />
    </main>
  );
}
